import React from 'react';
import InvestorInvestmentsContentSC, {
  TableInvestsContentWrapSC,
  TableOffersContentWrapSC,
} from './investor-investments-content.styled';

import InvestmentsTable from '../investments-table';
import { withRouter } from 'react-router-dom';
import OffersTable from '../offers-table';

const InvestorInvestmentsContent = () => {
  return (
    <InvestorInvestmentsContentSC>
      <TableInvestsContentWrapSC>
        <InvestmentsTable hasPagination hasAdditionalTop hasSelectAll hasFilter />
      </TableInvestsContentWrapSC>
      <TableOffersContentWrapSC>
        <OffersTable hasPagination hasAdditionalTop />
      </TableOffersContentWrapSC>
    </InvestorInvestmentsContentSC>
  );
};

export default withRouter(InvestorInvestmentsContent);
